import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { AshcorpPasswordRequirementComponent } from 'app/authentication/auth/ashcorp-password-requirement/password-requirement.component';
import { AshcorpLoaderComponent } from './ashcorp-loader/loader.component';
import { AshcorpErrorComponent } from './ashcorp-error/error.component';
import { AshcorpBackgroundComponent } from './ashcorp-background/background.component';
import { AshcorpInputComponent } from './ashcorp-controllers/input/input.component';
import { AshcorpFormComponent } from './ashcorp-form/form.component';
import { AshcorpMetaComponent } from './ashcorp-meta/meta.component';
import { AshcorpSelectComponent } from './ashcorp-controllers/select/select.component';
import { AshcorpApiSelectComponent } from './ashcorp-controllers/api-select/api-select.component';
import { AshcorpApiAutocompleteComponent } from './ashcorp-controllers/api-autocomplete/api-autocomplete.component';
import { AshcorpFileUploadComponent } from './ashcorp-controllers/file-upload/file-upload.component';
import { DatePipe } from './pipes/date.pipe';
import { LabelPipe } from './pipes/label.pipe';
import { ReadonlyGateDirective } from 'app/shared/lifecycle/readonly-gate.directive';

@NgModule({
    declarations: [
        AshcorpPasswordRequirementComponent,
        AshcorpLoaderComponent,

        AshcorpErrorComponent,
        AshcorpInputComponent,
        AshcorpFormComponent,
        AshcorpMetaComponent,
        AshcorpSelectComponent,
        AshcorpApiSelectComponent,
        AshcorpApiAutocompleteComponent,
        AshcorpFileUploadComponent,
        DatePipe,
        LabelPipe

    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatExpansionModule,
        ReadonlyGateDirective,
        AshcorpBackgroundComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AshcorpPasswordRequirementComponent,
        AshcorpLoaderComponent,
        AshcorpErrorComponent,
        AshcorpBackgroundComponent,

        AshcorpInputComponent,
        AshcorpFormComponent,
        AshcorpMetaComponent,
        AshcorpSelectComponent,
        AshcorpApiSelectComponent,
        AshcorpApiAutocompleteComponent,
        AshcorpFileUploadComponent,
        DatePipe,
        LabelPipe,
        ReadonlyGateDirective,
    ]
})
export class SharedModule {
}
